import { sm3 } from 'sm-crypto-v2'
import { hexToBase64 } from './util'

/**
 * SM3工具类
 */
export class SM3Utils {
  /**
   * 计算SM3哈希值
   *
   * @param data 输入数据
   * @return 哈希值的十六进制字符串
   */
  public static hash(data: string): string {
    try {
      return sm3(data)
    }
    catch (error) {
      console.error('SM3哈希计算失败', error)
      throw new Error('SM3哈希计算失败')
    }
  }

  /**
   * 生成签名内容
   * 按照key字母顺序排序，拼接成 key1=value1&key2=value2 格式
   */
  public static getSignatureContent(map: Map<string, string>): string {
    const keys = Array.from(map.keys()).sort()
    return keys.map((key, index) => {
      const value = map.get(key)
      return `${index === 0 ? '' : '&'}${key}=${value}`
    }).join('')
  }

  /**
   * 使用HMAC-SM3计算签名
   */
  public static calculateHmacSm3(content: string, key: string): string {
    try {
      // 使用sm-crypto-v2库中的hmac模式
      const hmacResult = sm3(content, {
        key,
        mode: 'hmac',
      })

      return hexToBase64(hmacResult)
    }
    catch (error) {
      console.error('HMAC-SM3签名计算失败', error)
      throw new Error('HMAC-SM3签名计算失败')
    }
  }
}
